import { render, staticRenderFns } from "./PromoHint.vue?vue&type=template&id=757526ae&scoped=true&"
import script from "./PromoHint.vue?vue&type=script&lang=js&"
export * from "./PromoHint.vue?vue&type=script&lang=js&"
import style0 from "./PromoHint.vue?vue&type=style&index=0&id=757526ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757526ae",
  null
  
)

export default component.exports